import axios from "axios";
import { IWidgetResponse } from "../Base/Base.types";
import {ITEUByMonth} from "./TEUByMonth.types";

export default class TEUByMonthApi {
    static async getData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/TEUByMonth`, {params: rawQuery});
            return res.data as IWidgetResponse<ITEUByMonth>;
        } catch (e: any) {
            console.error('Could not get TEUByMonth data: ', e.message);
            return undefined;
        }
    }
}